var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#73C7A9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5125 1.14258L21 7.63014L14.5125 13.7573V9.79266C9.4666 9.79266 7.30408 15.199 7.30408 15.199C7.30408 9.07182 9.10618 5.1072 14.5125 5.1072V1.14258Z",
    fill: "#73C7A9",
    stroke: "#333333",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02623 2.58398H8.74536C8.94938 2.58405 9.14577 2.66155 9.29485 2.80083C9.44393 2.94012 9.53458 3.13079 9.54848 3.33434C9.56239 3.53788 9.49852 3.73912 9.36977 3.89738C9.24102 4.05565 9.05699 4.15914 8.85488 4.18695L8.74536 4.19446H5.02623C4.41428 4.19437 3.82511 4.42652 3.37771 4.84403C2.93031 5.26153 2.65803 5.83328 2.61588 6.44377L2.61051 6.61018V16.8099C2.61071 17.4218 2.84313 18.0109 3.26083 18.4581C3.67854 18.9053 4.25039 19.1773 4.86089 19.2192L5.02623 19.2256H15.2259C15.8382 19.226 16.4278 18.9938 16.8755 18.576C17.3231 18.1583 17.5955 17.5861 17.6374 16.9752L17.6427 16.8099V16.2752C17.6428 16.0712 17.7203 15.8748 17.8596 15.7257C17.9989 15.5766 18.1895 15.486 18.3931 15.4721C18.5966 15.4582 18.7979 15.5221 18.9561 15.6508C19.1144 15.7796 19.2179 15.9636 19.2457 16.1657L19.2532 16.2752V16.8099C19.253 17.8406 18.8575 18.832 18.1483 19.5798C17.439 20.3276 16.4699 20.775 15.4407 20.8296L15.2259 20.8361H5.02623C3.99535 20.8362 3.00371 20.4408 2.25565 19.7315C1.50759 19.0222 1.0601 18.053 1.0054 17.0235L1.00003 16.8088V6.60911C1.00021 5.57859 1.39553 4.58737 2.10459 3.83957C2.81364 3.09177 3.78245 2.64431 4.8115 2.58935L5.02623 2.58398Z",
    fill: "#73C7A9",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.75f7889921d2a6b45af7bf1bf65eb020.svg";
export { ForwardRef as ReactComponent };